import api from './api';
import { Dependent, DependentFormData, DependentLog, ApiResponse } from '../types';

export const dependentService = {
  async getAll(associateId: number): Promise<Dependent[]> {
    const response = await api.get<Dependent[]>(`/associates/${associateId}/dependents`);
    return response.data;
  },

  async create(associateId: number, data: DependentFormData): Promise<ApiResponse<Dependent>> {
    const response = await api.post<ApiResponse<Dependent>>(`/associates/${associateId}/dependents`, data);
    return response.data;
  },

  async update(associateId: number, dependentId: number, data: DependentFormData): Promise<ApiResponse<Dependent>> {
    const response = await api.put<ApiResponse<Dependent>>(
      `/associates/${associateId}/dependents/${dependentId}`,
      data
    );
    return response.data;
  },

  async delete(associateId: number, dependentId: number): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(
      `/associates/${associateId}/dependents/${dependentId}`
    );
    return response.data;
  },

  async updateStatus(
    associateId: number,
    dependentId: number,
    status: 'ativo' | 'inativo',
    reason: string,
    notes?: string
  ): Promise<ApiResponse<Dependent>> {
    const response = await api.patch<ApiResponse<Dependent>>(
      `/associates/${associateId}/dependents/${dependentId}/status`,
      { status, reason, notes: notes || null }
    );
    return response.data;
  },

  async getLogs(associateId: number, dependentId: number): Promise<DependentLog[]> {
    const response = await api.get<DependentLog[]>(
      `/associates/${associateId}/dependents/${dependentId}/logs`
    );
    return response.data;
  },
};
